import React from "react";
import { User } from "@common/types/user";
import { useActiveWorkspaceRole } from "@hooks/permissions/useActiveWorkspaceRole";
import { Tag } from "@components/general/Tag/Tag";
import { WORKSPACE_ROLES_LABELS } from "@common/constants";
import styles from "./UserDropdownHeader.module.scss";

interface UserDropdownHeaderProps {
    user: User;
}

export const UserDropdownHeader: React.FC<UserDropdownHeaderProps> = ({
    user,
}) => {
    const roleInWorkspace = useActiveWorkspaceRole();

    return (
        <div className={styles.userDropdownHeader}>
            <div
                className={styles.userDropdownUserName}
                data-testid="dropdown-user-name"
            >
                {user.name}
            </div>
            <div
                className={styles.userDropdownUserEmail}
                data-testid="dropdown-user-email"
            >
                {user.email}
            </div>

            {roleInWorkspace ? (
                <div className={styles.userDropdownUserRole}>
                    <Tag size="sm" variant="secondary" outline>
                        {WORKSPACE_ROLES_LABELS[roleInWorkspace]}
                    </Tag>
                </div>
            ) : null}
        </div>
    );
};
